import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap';


export abstract class ClosableComponent {


    protected constructor(bsModalRef: BsModalRef) {
        this.bsModalRef = bsModalRef;
        this.onClose = new Subject();
        this.onCloseWithResponse = new Subject();
    }

    public onClose: Subject<boolean>;
    public onCloseWithResponse: Subject<any>;
    public bsModalRef: BsModalRef;


    close() {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    closeWithResponse(response: any) {
        this.onCloseWithResponse.next(response);
        this.bsModalRef.hide();
    }
}
